import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class Alert extends Component {

    onClick() {

        const { path } = this.props

        if (path) {
            this.props.history.push(path)
        }
    }

    render() {
        return (<div role="alert" className={'alert alert-theme alert-success alert-dismissible' + (this.props.path ? ' hover' : '')} onClick={() => {this.onClick()}}>
            <span className="icon s7-check"></span>{this.props.message}
        </div>);
    }

}

export default withRouter(Alert)



// WEBPACK FOOTER //
// ./src/components/Success/Alert.js